import { Skeleton } from '@crehana/compass.ui/v3/skeleton';

const DETAIL_CELL_COUNT = 6;
const DETAIL_CELL_KEYS = Array.from(
  { length: DETAIL_CELL_COUNT },
  (_unused, index) => `detail-skeleton-${index}`,
);

const COMMENT_ROW_COUNT = 3;
const COMMENT_ROW_KEYS = Array.from(
  { length: COMMENT_ROW_COUNT },
  (_unused, index) => `comment-skeleton-${index}`,
);

export const RequestDetailSkeleton = () => (
  <div
    data-testid="request-detail-skeleton"
    className="tw-flex tw-flex-col tw-cds-gap-6"
  >
    <div className="tw-grid tw-grid-cols-2 tw-cds-gap-5">
      {DETAIL_CELL_KEYS.map(cellKey => (
        <Skeleton
          key={cellKey}
          layer="01"
          className="tw-flex tw-flex-col tw-cds-gap-2"
        >
          <Skeleton.Block className="tw-h-1.6 tw-w-9.6 tw-cds-rounded-s" />
          <Skeleton.Text size="sm" />
        </Skeleton>
      ))}
    </div>
    <Skeleton layer="01" className="tw-flex tw-flex-col tw-cds-gap-2">
      <Skeleton.Block className="tw-h-1.6 tw-w-9.6 tw-cds-rounded-s" />
      <Skeleton.Text size="sm" />
    </Skeleton>
    <div className="tw-flex tw-flex-col tw-cds-gap-4 tw-cds-p-4">
      {COMMENT_ROW_KEYS.map(rowKey => (
        <Skeleton key={rowKey} layer="01" className="tw-flex tw-cds-gap-3">
          <Skeleton.Avatar size="sm" />
          <div className="tw-flex tw-flex-1 tw-flex-col tw-cds-gap-2">
            <Skeleton.Block className="tw-h-1.6 tw-w-9.6 tw-cds-rounded-s" />
            <Skeleton.Text size="sm" />
          </div>
        </Skeleton>
      ))}
    </div>
  </div>
);
